import { Component, DoCheck, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./../home/home.page.scss', './privacy-policy.page.scss'],
})
export class PrivacyPolicyPage implements OnInit, DoCheck {
  web: string;
  year: any;
  formUrl: string;
  loading: boolean;
  loading2: boolean;

  constructor(private homePageService: HomePageService) { }
  submitNewsletterForm() {
    this.homePageService.submitNewsletterForm();
  }

  submitContactForm() {
    this.homePageService.submitContactForm();
  }

  ionViewWillEnter() {
    document.title = 'Privacy Policy | Bank3D';
  }

  ngOnInit() {
    this.web = this.homePageService.web;
    this.year = this.homePageService.year;
    this.formUrl = this.homePageService.formUrl;
    this.homePageService.shared();
  }

  ngDoCheck(): void {
    this.loading = this.homePageService.loading;
    this.loading2 = this.homePageService.loading2;
  }
}
